import { motion } from "framer-motion";
import { ChatCircleDots, PencilLine, MicrophoneStage, Gift } from "@phosphor-icons/react";
import { useLang } from "@/context/LanguageContext";

const meta = [
  { n: "01", icon: ChatCircleDots, color: "hsl(351 100% 88%)" },
  { n: "02", icon: PencilLine, color: "hsl(298 55% 85%)" },
  { n: "03", icon: MicrophoneStage, color: "hsl(200 75% 82%)" },
  { n: "04", icon: Gift, color: "hsl(45 100% 82%)" },
];

export default function HowItWorks() {
  const { t } = useLang();
  const steps = t("how.steps");
  const chapters = meta.map((m, i) => ({ ...m, title: steps[i].title, text: steps[i].text }));
  return (
    <section id="como-funciona" className="relative py-24 max-w-7xl mx-auto px-5 sm:px-8">
      <div className="max-w-2xl mb-16">
        <motion.p
          initial={{ opacity: 0, x: -20 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          className="font-hand text-3xl text-primary mb-2"
        >
          {t("how.kicker")}
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ type: "spring", stiffness: 120, damping: 18 }}
          className="font-display font-bold text-3xl sm:text-4xl lg:text-5xl lg:whitespace-nowrap tracking-tight text-foreground"
        >
          {t("how.title")}
        </motion.h2>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {chapters.map((c, i) => {
          const Icon = c.icon;
          return (
            <motion.div
              key={c.n}
              data-testid={`step-${c.n}`}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ type: "spring", stiffness: 140, damping: 18, delay: i * 0.1 }}
              whileHover={{ y: -8, rotate: i % 2 ? 1.5 : -1.5 }}
              className="relative rounded-[2rem] bg-white p-7 shadow-glass border border-white"
            >
              <div
                className="w-16 h-16 rounded-2xl flex items-center justify-center mb-5"
                style={{ background: c.color }}
              >
                <Icon weight="duotone" size={34} className="text-foreground" />
              </div>
              <span className="font-display font-bold text-5xl text-foreground/10 absolute top-5 right-6">{c.n}</span>
              <h3 className="font-display font-semibold text-xl text-foreground mb-2">{c.title}</h3>
              <p className="text-sm text-foreground/60 font-medium leading-relaxed">{c.text}</p>
            </motion.div>
          );
        })}
      </div>
    </section>
  );
}
